import React from "react";
import { Box, Skeleton } from "@mui/material";
import {
  CardContainer,
  CardContent,
  CARD_IMAGE_HEIGHT,
  ImageWrapper,
} from "../PublicItem/styledComponents";
import { useSkeletonAnimation } from "../../hooks/useSkeletonAnimation";

/**
 * A placeholder in the shape of `PublicItem` (EB-543).
 *
 * It reuses the real card's shell rather than approximating it, so the grid it fills is exactly as
 * tall as the grid that replaces it — which is the whole point. A placeholder that is merely
 * *similar* still shifts the page when the data lands, it just does it more prettily.
 */
const ProductCardSkeleton: React.FC = () => {
  const animation = useSkeletonAnimation();

  return (
    <CardContainer aria-hidden>
      {/* The rating / share / favourite row. 30px circles put this row at the 34px the real one
          measures — the icon buttons there are MUI's default size, not the 24px they look. */}
      <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1} px={1} pt={0.5}>
        <Skeleton
          animation={animation}
          variant="rounded"
          width={72}
          height={16}
          sx={{ mr: "auto" }}
        />
        <Skeleton animation={animation} variant="circular" width={30} height={30} />
        <Skeleton animation={animation} variant="circular" width={30} height={30} />
      </Box>

      <ImageWrapper>
        <Skeleton animation={animation} variant="rounded" width="100%" height={CARD_IMAGE_HEIGHT} />
      </ImageWrapper>

      <CardContent>
        {/* Price, then the product name. */}
        <Skeleton animation={animation} variant="text" width="45%" height={22} />
        <Skeleton animation={animation} variant="text" width="90%" height={18} />
        <Skeleton animation={animation} variant="text" width="60%" height={18} />

        {/* "Ver más" keeps its corner so the card's bottom edge does not move. */}
        <Box mt="auto" pt={1} display="flex" justifyContent="flex-end">
          <Skeleton animation={animation} variant="rounded" width={92} height={26} />
        </Box>
      </CardContent>
    </CardContainer>
  );
};

export default ProductCardSkeleton;
